import { defineAction } from '~/prix'
import geoCalculateOptimizedRouteAction from './geoCalculateOptimizedRoute.action.json' with { type: 'json' }
import { featureCollection, lineString, point } from '~/prix/types/presets/geo'
import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'

const geoCalculateOptimizedRouteDefinition = defineAction({
  ...geoCalculateOptimizedRouteAction,

  input: z.object({
    points: featureCollection(point()).describe('Pontos'),
    roundtrip: z.boolean().describe('Retorno ao ponto de origem').default(false),
    source: enumerated({
      any: 'Qualquer ponto',
      first: 'Primeiro ponto',
    })
      .default('any')
      .describe('Ponto de origem'),
    destination: enumerated({
      any: 'Qualquer ponto',
      last: 'Último ponto',
    })
      .default('any')
      .describe('Ponto de destino'),
  }),
  output: z.object({
    route: featureCollection(lineString()).describe('Rota'),
  }),
})

export default geoCalculateOptimizedRouteDefinition
